// extracted by css-extract-rspack-plugin
export default {"infoBar":"ewfnm3"};